// src/pages/NavigatorMyAvailabilityPage.jsx
// Route: /navigator/availability
//
// A navigator setting their own working hours and days off — "on his login,
// can set up his schedule / non-availability just like a doctor." No id
// passed anywhere here, same reasoning as DoctorMyAvailabilityPage: the
// backend's /me family resolves the navigator server-side from the JWT.
// Unlike the doctor case there's no identity-duality trap to route around —
// a navigator's own login IS their navigators.id — but the same "self"
// mode/no-id shape was kept for consistency with DoctorAvailabilityEditor.

import React from 'react';
import { AppShell } from '../components/Layout';
import DoctorAvailabilityEditor from '../components/DoctorAvailabilityEditor';

export default function NavigatorMyAvailabilityPage() {
  return (
    <AppShell breadcrumbs={[{ label: 'My Availability' }]}>
      <DoctorAvailabilityEditor mode="self" kind="navigator" />
    </AppShell>
  );
}
